import React from 'react';

export default function RecentTransaction() {
	const columns = [
		{
			key: 'date',
			label: 'DATE',
		},
		{
			key: 'transaction_details',
			label: 'TRANSACTION DETAILS',
		},
		{
			key: 'type',
			label: 'TYPE',
		},
		{
			key: 'debit',
			label: 'DEBIT',
		},
		{
			key: 'credit',
			label: 'CREDIT',
		},
		{
			key: 'reference',
			label: 'REFERENCE',
		},
	];
	const row = [
		{
			date: 'April 5, 2026',
			transaction_details: 'Software Technologies Pvt. Ltd',
			type: 'Income',
			debit: '-',
			credit: '₹253.00',
			reference: 'INV-0000-00000',
		},
		{
			date: 'April 5, 2026',
			transaction_details: 'Software Technologies Pvt. Ltd',
			type: 'Income',
			debit: '-',
			credit: '₹253.00',
			reference: 'INV-0000-00000',
		},
		{
			date: 'April 5, 2026',
			transaction_details: 'Software Technologies Pvt. Ltd',
			type: 'Income',
			debit: '-',
			credit: '₹253.00',
			reference: 'INV-0000-00000',
		},
		{
			date: 'April 5, 2026',
			transaction_details: 'Software Technologies Pvt. Ltd',
			type: 'Income',
			debit: '-',
			credit: '₹253.00',
			reference: 'INV-0000-00000',
		},
	];
	return (
		<div className="bg-white p-3 mx-4 my-2 rounded-4">
			<div className="d-flex justify-content-between align-items-center pb-3 px-1">
				<div className="fs-5 fw-light text-black">Recent Transactions</div>
				<div className="fs-5 fw-light text-primary cursor-pointer">View All</div>
			</div>
			<div className="table-container">
				<table className="custom-table">
					<thead>
						<tr>
							{columns.map((m, idx) => (
								<th
									className={'cursor-pointer'}
									key={`${idx}`}
								>
									<div className=" fs-6 fw-bold d-flex justify-content-start align-items-center gap-4">
										{m.label}
									</div>
								</th>
							))}
						</tr>
					</thead>

					<tbody style={{ height: '180px' }}>
						{row.map((rowItem, i) => (
							<tr key={i}>
								{columns.map((m, idx) => {
									return (
										<td
											key={`${i}-${idx}`}
											className="fs-6 fw-light"
										>
											{rowItem[m.key]}
										</td>
									);
								})}
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
}
